import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-merchant-solutions.component.scss';
var FormItemMerchantSolutions = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemMerchantSolutions, _super);
    function FormItemMerchantSolutions(element) {
        return _super.call(this, element) || this;
    }
    FormItemMerchantSolutions.prototype.init = function () {
        this.applyForm = this.element.querySelector("form");
        // buttons
        this.applyFormSubmit = Array.from(this.element.querySelectorAll(".js-merchant-solutions__button"));
        // display views
        if (this.applyForm) {
            this.displayLoader = this.applyForm.querySelector(".form__loader--container");
            this.displayFields = this.applyForm.querySelector(".form__fields--container");
            this.displaySuccess = this.applyForm.querySelector(".form__success--container");
            this.displayFail = this.applyForm.querySelector(".form__error--container");
        }
        this.containerModal = this.element.closest('.form-container');
        this.closeButton = this.containerModal.querySelector('.js-apply-now-modal-close');
        // input fields
        this.identificationSelection = Array.from(this.element.querySelectorAll(".js-identification_radio--group"));
        this.initFieldLengths();
    };
    FormItemMerchantSolutions.prototype.bindEvents = function () {
        var _this = this;
        this.applyFormSubmit.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.resetClass(); });
        }
        if (this.identificationSelection) {
            this.identificationSelection.map(function (item) {
                item.addEventListener("click", function (event) {
                    var evt = event.target;
                    var identificationField = _this.applyForm.querySelector("input[name=identification]");
                    var _identityType = evt.value;
                    if (_identityType === "01") {
                        identificationField.classList.remove("form__input--identification--passport");
                        identificationField.classList.add("form__input--identification");
                        identificationField.placeholder = "Enter your South African ID number";
                        identificationField.value = "";
                        identificationField.type = "number";
                    }
                    else {
                        identificationField.classList.remove("form__input--identification");
                        identificationField.classList.add("form__input--identification--passport");
                        identificationField.placeholder = "Enter your Passport number";
                        identificationField.value = "";
                        identificationField.type = "text";
                    }
                });
            });
        }
        // Reset the form
        this.applyForm.addEventListener("custom_form_reset_event", function (e) {
            _this.resetForm();
        }, false);
    };
    FormItemMerchantSolutions.prototype.resetClass = function () {
        var _this = this;
        this.identificationSelection.map(function (item) {
            var identificationField = _this.applyForm.querySelector("input[name=identification]");
            identificationField.classList.remove("form__input--identification--passport");
            identificationField.classList.add("form__input--identification");
            identificationField.placeholder = "Enter your South African ID number";
            identificationField.value = "";
            identificationField.type = "number";
        });
    };
    FormItemMerchantSolutions.prototype.resetForm = function () {
        if (this.applyForm) {
            this.applyForm.reset();
            this.showDisplayView("fields");
        }
    };
    FormItemMerchantSolutions.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        this.showDisplayView("");
        var _displayName = Array.from(form.querySelectorAll('.form__success-container__firstname'));
        var analyticsService = new AnalyticsService();
        // fields
        var _firstName = this.applyForm.querySelector("input[name=firstName]");
        var _surname = this.applyForm.querySelector("input[name=surname]");
        var _idType = this.applyForm.querySelector("input[name=identification-type]:checked");
        var _idNumber = this.applyForm.querySelector("input[name=identification]");
        var _contactNumber = this.applyForm.querySelector("input[name=contactNumber]");
        var _province = this.applyForm.querySelector("select[name=region]");
        var _popiConsent = this.applyForm.querySelector("input[name=popiConsent]");
        var _emailAddress = this.applyForm.querySelector("input[name=emailAddress]");
        var _emailSubject = this.applyForm.querySelector("input[name=subject]");
        var _description = this.applyForm.querySelector("input[name=description]");
        var errors = [];
        if (_contactNumber.value.length != 10) {
            errors.push('South African contact numbers are 10 digits');
        }
        if (!this.validSAContact(_contactNumber)) {
            errors.push('This contact number is invalid');
        }
        if (errors.length !== 0) {
            this.showDisplayView('fields');
            analyticsService.dtmFormComplete("complete", "false");
            this.validationService.addErrorMessage(_contactNumber, errors);
            return;
        }
        if (_idType.value === "01" && !this.validSAIDNo(_idNumber)) {
            this.showDisplayView('fields');
            analyticsService.dtmFormComplete("complete", "false");
            this.validationService.addErrorMessage(_idNumber, ['South Africa ID number is invalid']);
            return;
        }
        var _postData = {
            firstname: (_firstName ? _firstName.value : ""),
            surname: (_surname ? _surname.value : ""),
            idType: (_idType ? _idType.value : ""),
            IdNumber: (_idNumber ? _idNumber.value : ""),
            contact: (_contactNumber ? _contactNumber.value : ""),
            emailAddress: (_emailAddress ? _emailAddress.value : ""),
            province: (_province ? _province.value : ""),
            subject: (_emailSubject ? _emailSubject.value : ""),
            popiConsent: ((_popiConsent && _popiConsent.checked) ? "YES" : "NO"),
            description: (_description ? _description.value : "")
        };
        // variables
        var url = this.baseUrl + "/services/MerchantSolutionsForm.jsp";
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData)).then(function (response) {
            var _response = response.data;
            if (_response.toString().includes('invalid')) {
                // service failed
                analyticsService.dtmFormComplete("complete", "false");
                _this.showDisplayView("fail");
            }
            else {
                if (_displayName) {
                    _displayName.map(function (pElement) {
                        pElement.innerHTML = _postData.firstname;
                    });
                }
                analyticsService.dtmFormComplete("complete", "true");
                _this.showDisplayView("success");
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmFormComplete("complete", "false");
            this.showDisplayView("fail");
        });
    };
    FormItemMerchantSolutions.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.remove("active");
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.remove("active");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.remove("active");
        this.displaySuccess.classList.add("hidden");
        this.displayFail.classList.remove("active");
        this.displayFail.classList.add("hidden");
        switch (pDisplay) {
            case "fields":
                this.displayFields.classList.add("active");
                this.displayFields.classList.remove("hidden");
                break;
            case "success":
                this.displaySuccess.classList.add("active");
                this.displaySuccess.classList.remove("hidden");
                break;
            case "fail":
                this.displayFail.classList.add("active");
                this.displayFail.classList.remove("hidden");
                break;
            default:
                this.displayLoader.classList.add("active");
                this.displayLoader.classList.remove("hidden");
                break;
        }
    };
    FormItemMerchantSolutions.prototype.initFieldLengths = function () {
        var _firstName = this.applyForm.querySelector("input[name=firstName]");
        _firstName.setAttribute("maxlength", "80");
        var _surname = this.applyForm.querySelector("input[name=surname]");
        _surname.setAttribute("maxlength", "80");
        var _contactNumber = this.applyForm.querySelector("input[name=contactNumber]");
        _contactNumber.setAttribute("maxlength", "10");
        var _emailAddress = this.applyForm.querySelector("input[name=emailAddress]");
        _emailAddress.setAttribute("maxlength", "80");
    };
    FormItemMerchantSolutions.prototype.validSAContact = function (field) {
        var is_zero_number_correct = true;
        var num;
        num = /^0[0-9]\d{8}$/g;
        if (num.test(field.value) === false) {
            is_zero_number_correct = false;
        }
        else {
            is_zero_number_correct = true;
        }
        return is_zero_number_correct;
    };
    FormItemMerchantSolutions.prototype.validatePassport = function (field) {
        var valid = true;
        var input = field;
        var passportRegex = new RegExp("^[a-zA-Z0-9]*$");
        if (!passportRegex.test(input.value)) {
            if (field.value) {
                valid = false;
            }
        }
        return valid;
    };
    FormItemMerchantSolutions.prototype.validSAIDNo = function (field) {
        var idNumber = field.value;
        var year = Number(idNumber.substring(0, 2));
        var month = Number(idNumber.substring(2, 4));
        var day = Number(idNumber.substring(4, 6));
        // Determine the full year based on the first two digits of the ID number
        var currentYear = new Date().getFullYear() % 100;
        var fullYear;
        if (year <= currentYear) {
            fullYear = 2000 + year;
        }
        else {
            fullYear = 1900 + year;
        }
        // Check if the birthdate is valid
        if (fullYear < 1900 || fullYear > currentYear + 2000 || month < 1 || month > 12 || day < 1 || day > 31) {
            return false;
        }
        var idArray = idNumber.split('').map(Number);
        var checksum = idArray[12];
        var weightedSum = idArray
            .slice(0, 12)
            .map(function (digit, index) { return (index % 2 === 0 ? digit : digit * 2); })
            .map(function (digit) { return (digit > 9 ? digit - 9 : digit); })
            .reduce(function (acc, curr) { return acc + curr; }, 0);
        var calculatedChecksum = (10 - (weightedSum % 10)) % 10;
        return calculatedChecksum === checksum;
    };
    return FormItemMerchantSolutions;
}(Base));
export { FormItemMerchantSolutions };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-merchant-solutions/form-item-merchant-solutions.component.ts
// module id = 925
// module chunks = 0